import React from 'react'
import { NewNavbar } from './NewNavbar'

interface NewAppLayoutProps {
  children: React.ReactNode
  /**
   * When true, drops the max-w-[1280px] cap and center alignment.
   * Use for legacy pages with wide data tables or multi-pane layouts
   * (MailboxManagement, DomainsEmailsManagement, MasterCRMLayout,
   * SendingInfrastructure, AIReplyTagger, Logs, CampaignDetail, etc.).
   * New UX pages should omit this and get the 1280px cap.
   */
  fullWidth?: boolean
  /**
   * When true, removes the inner padding wrapper entirely so the page
   * can manage its own full-bleed layout (e.g. NewCRMPage uses an
   * in-page sidebar + main with its own padding values that must match
   * the wireframe exactly). Implies fullWidth.
   */
  noPadding?: boolean
}

export function NewAppLayout({ children, fullWidth = false, noPadding = false }: NewAppLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col" style={{ background: '#f4f5f9' }}>
      <NewNavbar />
      <main className="flex-1 overflow-y-auto">
        {noPadding ? (
          children
        ) : (
          <div className={fullWidth ? 'w-full px-6 py-6' : 'max-w-[1280px] mx-auto p-6'}>
            {children}
          </div>
        )}
      </main>
    </div>
  )
}
